import TechnicalOverlayChart from './TechnicalOverlayChart';

export default TechnicalOverlayChart;
